import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import QuotoWrapper from "@components/layouts/quotoWrapper";

export default function QuotoHome(): ReactElement {
    return (
        <QuotoWrapper>
            <PrivacyPolicy domain="quoto.com" category="B2B" />
        </QuotoWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
